import React, { Component } from 'react';
import { format, parse, isValid } from 'date-fns';
import { es } from 'date-fns/locale';
import DateFnsUtils from '@date-io/date-fns';
import { withStyles } from '@material-ui/styles';
import styles from './styles';
import {
    Container,
    MenuItem,
    Typography,
    InputAdornment,
    IconButton,
} from '@material-ui/core';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';

import { BotonPrincipal, BotonSecundario } from '../../common/UI/Personalizaciones/Boton';

import {
    TextFieldCustom,
    TextFieldDate,
} from '../../common/UI/Personalizaciones/TextField';
import clearInputIcon from '../../../assets/iconos/clear-input-icon.png';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';


class Filtros extends Component {
    state = {
        nroPresentacion: '',
        nroRecepcion: '',
        codPrestador: '',
        estadoSeleccionadoId: '',
        fechaEstadoDesde: null,
        fechaEstadoHasta: null,
        fechaPresentacionDesde: null,
        fechaPresentacionHasta: null,
        fechaVencDesde: null,
        fechaVencHasta: null,
    };

     handleLocalStorage = async () =>
    {
        if(localStorage.length > 0){
            const filtrosCambiados = sessionStorage.getItem('filtrosCambiados');
            this.setState({
                nroPresentacion: localStorage.getItem('nroPresentacion')?parseInt(localStorage.getItem('nroPresentacion')):'',
                nroRecepcion: localStorage.getItem('nroRecepcion')?parseInt(localStorage.getItem('nroRecepcion')):'',
                codPrestador: localStorage.getItem('codPrestador')?parseInt(localStorage.getItem('codPrestador')):'',
                estadoSeleccionadoId: localStorage.getItem('estadoSeleccionadoId')?this.actualizarFiltroEstado(localStorage.getItem('estadoSeleccionadoId')):'',
                fechaEstadoDesde: localStorage.getItem('fechaEstadoDesde')?this.handleDateLocalStorage(localStorage.getItem('fechaEstadoDesde'), 'yyyy-MM-dd HH:mm:ss'):null,
                fechaEstadoHasta: localStorage.getItem('fechaEstadoHasta')?this.handleDateLocalStorage(localStorage.getItem('fechaEstadoHasta'), 'yyyy-MM-dd HH:mm:ss'):null,
                fechaPresentacionDesde: localStorage.getItem('fechaPresentacionDesde')?this.handleDateLocalStorage(localStorage.getItem('fechaPresentacionDesde'), 'yyyy-MM-dd HH:mm:ss'):null,
                fechaPresentacionHasta: localStorage.getItem('fechaPresentacionHasta')?this.handleDateLocalStorage(localStorage.getItem('fechaPresentacionHasta'), 'yyyy-MM-dd HH:mm:ss'):null,
                fechaVencDesde: localStorage.getItem('fechaVencDesde')?this.handleDateLocalStorage(localStorage.getItem('fechaVencDesde'), 'yyyy-MM-dd HH:mm:ss'):null,
                fechaVencHasta: localStorage.getItem('fechaVencHasta')?this.handleDateLocalStorage(localStorage.getItem('fechaVencHasta'), 'yyyy-MM-dd HH:mm:ss'):null,
            });
            const localStorageObj = {
                nroPresentacion: (localStorage.getItem('nroPresentacion')?parseInt(localStorage.getItem('nroPresentacion')):''),
                nroRecepcion: localStorage.getItem('nroRecepcion')?parseInt(localStorage.getItem('nroRecepcion')):'',
                codPrestador: localStorage.getItem('codPrestador')?parseInt(localStorage.getItem('codPrestador')):'',
                estadoSeleccionadoId: localStorage.getItem('estadoSeleccionadoId')?this.actualizarFiltroEstado(localStorage.getItem('estadoSeleccionadoId')):'',
                fechaEstadoDesde: localStorage.getItem('fechaEstadoDesde')?this.handleDateLocalStorage(localStorage.getItem('fechaEstadoDesde'), 'yyyy-MM-dd'):null,
                fechaEstadoHasta: localStorage.getItem('fechaEstadoHasta')?this.handleDateLocalStorage(localStorage.getItem('fechaEstadoHasta'), 'yyyy-MM-dd'):null,
                fechaPresentacionDesde: localStorage.getItem('fechaPresentacionDesde')?this.handleDateLocalStorage(localStorage.getItem('fechaPresentacionDesde'), 'yyyy-MM-dd'):null,
                fechaPresentacionHasta: localStorage.getItem('fechaPresentacionHasta')?this.handleDateLocalStorage(localStorage.getItem('fechaPresentacionHasta'), 'yyyy-MM-dd'):null,
                fechaVencDesde: localStorage.getItem('fechaVencDesde')?this.handleDateLocalStorage(localStorage.getItem('fechaVencDesde'), 'yyyy-MM-dd'):null,
                fechaVencHasta: localStorage.getItem('fechaVencHasta')?this.handleDateLocalStorage(localStorage.getItem('fechaVencHasta'), 'yyyy-MM-dd'):null,
            };
            sessionStorage.setItem('filtrosCambiados', filtrosCambiados);
            this.props.actualizarFiltros(localStorageObj);
        }
    }

    componentDidMount() {
        this.handleLocalStorage().then(() => {
            this.props.buscarHandler();
        });
        document.addEventListener("keypress", this.handleKeyPress);
    }
    
    componentWillUnmount() {
        document.removeEventListener("keypress", this.handleKeyPress);
    }
    
    handleKeyPress = (evt) => {
        if (evt.key === "Enter" && sessionStorage.getItem("filtrosCambiados") === "true") {
            evt.preventDefault();
            this.props.buscarHandler();
        }
    };

    handleDateLocalStorage = (valor, formato) =>{
        if(valor !== "null")
        {
            if(formato === 'yyyy-MM-dd')
            {
                if (valor && !valor.includes('_')) 
                {
                    const fecha = parse(valor, 'dd/MM/yyyy', new Date());
                    
                    //guardo la fecha antes de formatearla
                    if (isValid(fecha)) 
                    {
                        const fechaFormateada = format(fecha, formato);
            
                        return fechaFormateada;              
                    }  
                }
            }else{
                if (valor && !valor.includes('_')) 
                {
                    const fecha = parse(valor, 'dd/MM/yyyy', new Date());
                    
                    //guardo la fecha antes de formatearla
                    if (isValid(fecha)) 
                    {
                        const fechaFormateada = format(fecha, formato);
            
                        return fechaFormateada;              
                    }  
                }
            }
       }else{
           return null;
       }
    }

    actualizarFiltroFecha = (clave, valor) => {
        if (valor && !valor.includes('_')) {
            const fecha = parse(valor, 'dd/MM/yyyy', new Date());
            

            if (isValid(fecha)) {
                const fechaFormateadaEstado = format(
                    fecha,
                    'yyyy-MM-dd HH:mm:ss'
                );
                

                const fechaFormateadaServidor = format(fecha, 'yyyy-MM-dd');

                this.setState({
                    [clave]: fechaFormateadaEstado,
                });
                const elementoFiltro = {};
                localStorage.setItem(clave,valor); 

                elementoFiltro[clave] = fechaFormateadaServidor;
                this.props.actualizarFiltros(elementoFiltro);
                sessionStorage.setItem('filtrosCambiados', true);
                    
            }
        } else if (valor === null || valor.length === 0) {
            this.setState({
                [clave]: null,
            });
            this.actualizarFiltro(clave, null);
        }
        
    };

    actualizarFiltroEstado = (valor) => {

        this.setState({
            estadoSeleccionadoId: valor,
        });
        localStorage.setItem('estadoSeleccionadoId',valor); //guardo el estado
        
        const elementoFiltro = { idEstado: '' };

        if (valor !== '') {
            const estadosSeleccionados = this.props.estados.filter((estado) => {
                return estado.descripcionWEB === valor;
            });

            elementoFiltro.idEstado = estadosSeleccionados.map(
                (elemento) => elemento.id
            );
        }
        
        this.props.actualizarFiltros(elementoFiltro);
        sessionStorage.setItem('filtrosCambiados', true);
    };

    actualizarFiltro = (clave, valor) => {
        this.setState({
            [clave]: valor,
        });
        localStorage.setItem(clave,valor); //guardo el filtro
        const elementoFiltro = {};

        elementoFiltro[clave] = valor;
        this.props.actualizarFiltros(elementoFiltro);
        sessionStorage.setItem('filtrosCambiados', true);
        
    };

    filtrarCaracteresCampoNumerico = (event) => {
        if (event.key.toLowerCase() === 'e' || event.key === '.') {
            event.preventDefault();
        }
    };

    dibujarSelectEstados = () => {
        const estadosAMostrar = this.props.estados.reduce(
            (resultado, estado) => {
                if (!resultado.includes(estado.descripcionWEB)) {
                    resultado.push(estado.descripcionWEB);
                }

                return resultado;
            },
            []
        );

        return estadosAMostrar.map((estado) => (
            <MenuItem key={estado} value={estado}>
                {estado}
            </MenuItem>
        ));
    };
    handleCleanFilter = ()=>{
        localStorage.clear();
        let cleaner = 
        {            
            nroPresentacion: '',
            nroRecepcion: '',
            codPrestador: '',
            estadoSeleccionadoId: '',
            fechaEstadoDesde: null,
            fechaEstadoHasta: null,
            fechaPresentacionDesde: null,
            fechaPresentacionHasta: null,
            fechaVencDesde: null,
            fechaVencHasta: null,
            idEstado:'',
          }
        this.setState({
            ...cleaner
         }
        )
        this.props.actualizarFiltros(cleaner);
        sessionStorage.setItem('filtrosCambiados', true);
    }

    render() {
        const { classes } = this.props;
        return (
            <Container className={classes.container} disableGutters={true}>
                <MuiPickersUtilsProvider utils={DateFnsUtils} locale={es}>
                    <div className={classes.filaContainer}>
                        <TextFieldCustom
                            id='nroPresentacion'
                            name='nroPresentacion'
                            label='Nº de presentación'
                            variant='outlined'
                            size='small'
                            type='number'
                            value={this.state.nroPresentacion}
                            className={classes.nroPresentacion}
                            onChange={(event) =>
                                this.actualizarFiltro(
                                    'nroPresentacion',
                                    event.target.value
                                )
                            }
                            onKeyPress={(event) =>
                                this.filtrarCaracteresCampoNumerico(event)
                            }
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position='end'>
                                        <IconButton
                                            size='small'
                                            onClick={() =>
                                                this.actualizarFiltro(
                                                    'nroPresentacion',
                                                    ''
                                                )
                                            }
                                        >
                                            <img
                                                src={clearInputIcon}
                                                alt='Vaciar contenido'
                                            />
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                        />
                        <TextFieldDate
                            clearable
                            disableToolbar
                            format='dd/MM/yyyy'
                            className={classes.filtroTextField}
                            inputVariant='outlined'
                            label='Presentación desde'
                            size='small'
                            value={this.state.fechaPresentacionDesde}
                            onChange={(event, date) =>
                                this.actualizarFiltroFecha(
                                    'fechaPresentacionDesde',
                                    date
                                )
                            }
                            KeyboardButtonProps={{
                                'aria-label': 'change date',
                            }}
                            okLabel='Ok'
                            clearLabel='Borrar'
                            cancelLabel='Cancelar'
                        />
                        <TextFieldDate
                            clearable
                            disableToolbar
                            format='dd/MM/yyyy'
                            label='Presentación hasta'
                            size='small'
                            className={classes.filtroTextField}
                            inputVariant='outlined'
                            value={this.state.fechaPresentacionHasta}
                            onChange={(event, date) =>
                                this.actualizarFiltroFecha(
                                    'fechaPresentacionHasta',
                                    date
                                )
                            }
                            KeyboardButtonProps={{
                                'aria-label': 'change date',
                            }}
                            okLabel='Ok'
                            clearLabel='Borrar'
                            cancelLabel='Cancelar'
                        />
                        <TextFieldCustom
                            id='estado'
                            name='estado'
                            label='Estado'
                            select
                            variant='outlined'
                            size='small'
                            className={classes.estado}
                            value={this.state.estadoSeleccionadoId}
                            onChange={(event) =>
                                this.actualizarFiltroEstado(event.target.value)
                            }
                            InputProps={
                                this.state.estadoSeleccionadoId !== ''
                                    ? {
                                          endAdornment: (
                                              <InputAdornment position='start'>
                                                  <IconButton
                                                      className={
                                                          classes.iconoClearEstado
                                                      }
                                                      size='small'
                                                      onClick={() =>
                                                          this.actualizarFiltroEstado(
                                                              ''
                                                          )
                                                      }
                                                  >
                                                      <img
                                                          src={clearInputIcon}
                                                          alt='Vaciar contenido'
                                                      />
                                                  </IconButton>
                                              </InputAdornment>
                                          ),
                                      }
                                    : null
                            }
                            SelectProps={{
                                IconComponent: (props) => (
                                    <KeyboardArrowDownIcon
                                        fontSize='small'
                                        className={`${classes.dropDownIcon}, ${props.className}`}
                                    />
                                ),
                            }}
                        >
                            {this.dibujarSelectEstados()}
                        </TextFieldCustom>
                        <TextFieldDate
                            disableToolbar
                            clearable
                            format='dd/MM/yyyy'
                            label='Estado desde'
                            size='small'
                            className={classes.filtroTextField}
                            inputVariant='outlined'
                            value={this.state.fechaEstadoDesde}
                            onChange={(event, date) =>
                                this.actualizarFiltroFecha(
                                    'fechaEstadoDesde',
                                    date
                                )
                            }
                            KeyboardButtonProps={{
                                'aria-label': 'change date',
                            }}
                            okLabel='Ok'
                            clearLabel='Borrar'
                            cancelLabel='Cancelar'
                        />
                        <TextFieldDate
                            disableToolbar
                            clearable
                            format='dd/MM/yyyy'
                            label='Estado hasta'
                            size='small'
                            className={classes.filtroTextField}
                            inputVariant='outlined'
                            value={this.state.fechaEstadoHasta}
                            onChange={(event, date) =>
                                this.actualizarFiltroFecha(
                                    'fechaEstadoHasta',
                                    date
                                )
                            }
                            KeyboardButtonProps={{
                                'aria-label': 'change date',
                            }}
                            okLabel='Ok'
                            clearLabel='Borrar'
                            cancelLabel='Cancelar'
                        />
                    </div>
                    <div className={classes.filaContainer}>
                        <TextFieldCustom
                            id='nroRecepcion'
                            name='nroRecepcion'
                            label='Nº de recepción'
                            variant='outlined'
                            type='number'
                            size='small'
                            className={classes.nroRecepcion}
                            value={this.state.nroRecepcion}
                            onChange={(event) =>
                                this.actualizarFiltro(
                                    'nroRecepcion',
                                    event.target.value
                                )
                            }
                            onKeyPress={(event) =>
                                this.filtrarCaracteresCampoNumerico(event)
                            }
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position='end'>
                                        <IconButton
                                            size='small'
                                            onClick={() =>
                                                this.actualizarFiltro(
                                                    'nroRecepcion',
                                                    ''
                                                )
                                            }
                                        >
                                            <img
                                                src={clearInputIcon}
                                                alt='Vaciar contenido'
                                            />
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                        />
                        <TextFieldCustom
                            id='codPrestador'
                            name='codPrestador'
                            label='Nº de prestador'
                            type='number'
                            size='small'
                            className={classes.nroPrestador}
                            value={this.state.codPrestador}
                            variant='outlined'
                            onChange={(event) =>
                                this.actualizarFiltro(
                                    'codPrestador',
                                    event.target.value
                                )
                            }
                            onKeyPress={(event) =>
                                this.filtrarCaracteresCampoNumerico(event)
                            }
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position='end'>
                                        <IconButton
                                            size='small'
                                            onClick={() =>
                                                this.actualizarFiltro(
                                                    'codPrestador',
                                                    ''
                                                )
                                            }
                                        >
                                            <img
                                                src={clearInputIcon}
                                                alt='Vaciar contenido'
                                            />
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                        />
                        <TextFieldDate
                            disableToolbar
                            clearable
                            format='dd/MM/yyyy'
                            label='Vencimiento desde'
                            size='small'
                            className={classes.filtroTextField}
                            inputVariant='outlined'
                            value={this.state.fechaVencDesde}
                            onChange={(event, date) =>
                                this.actualizarFiltroFecha(
                                    'fechaVencDesde',
                                    date
                                )
                            }
                            KeyboardButtonProps={{
                                'aria-label': 'change date',
                            }}
                            okLabel='Ok'
                            clearLabel='Borrar'
                            cancelLabel='Cancelar'
                        />
                        <TextFieldDate
                            disableToolbar
                            clearable
                            format='dd/MM/yyyy'
                            label='Vencimiento hasta'
                            className={classes.filtroTextField}
                            inputVariant='outlined'
                            size='small'
                            value={this.state.fechaVencHasta}
                            onChange={(event, date) =>
                                this.actualizarFiltroFecha(
                                    'fechaVencHasta',
                                    date
                                )
                            }
                            KeyboardButtonProps={{
                                'aria-label': 'change date',
                            }}
                            okLabel='Ok'
                            clearLabel='Borrar'
                            cancelLabel='Cancelar'
                        />
                        <BotonSecundario
                            variant= 'contained'
                            onClick={ this.handleCleanFilter }
                            className={classes.btnLimpiar}
                            >
                                Limpiar
                        </BotonSecundario>  
                        <BotonPrincipal
                            variant='contained'
                            onClick={this.props.buscarHandler}
                        >
                            Buscar
                        </BotonPrincipal>
                    </div>
                </MuiPickersUtilsProvider> 
            </Container>
        );
    }
}

export default withStyles(styles)(Filtros);
